import { render, staticRenderFns } from "./ModalCoupon.vue?vue&type=template&id=51910666&scoped=true"
import script from "./ModalCoupon.vue?vue&type=script&lang=js"
export * from "./ModalCoupon.vue?vue&type=script&lang=js"
import style0 from "./ModalCoupon.vue?vue&type=style&index=0&id=51910666&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51910666",
  null
  
)

export default component.exports